__webpack_require__.p = "https://d1ldwnjkukjs70.cloudfront.net/waldo-web-next/";